import { render, staticRenderFns } from "./EditExpress.vue?vue&type=template&id=18747e67&"
import script from "./EditExpress.vue?vue&type=script&lang=js&"
export * from "./EditExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports